import { render, staticRenderFns } from "./ReorderModal.vue?vue&type=template&id=675fcd1e&"
import script from "./ReorderModal.vue?vue&type=script&lang=js&"
export * from "./ReorderModal.vue?vue&type=script&lang=js&"
import style0 from "./ReorderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports